import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>
          Vivarius
        </h1>
		<p>Coming soon!</p>
      </header>
    </div>
  );
}

export default App;
